import React from 'react';
import { useState } from 'react';
import { HelpIcon, LocalizeButton } from '..';
export const FormGroup = ({ className, title, header, help, toggleableHelp = false, children }) => {
    const [showHelpText, setShowHelpText] = useState(false);
    //Callback used to toggle help text
    const helpButtonClickCallback = (e) => {
        e.preventDefault();
        setShowHelpText(!showHelpText);
    };
    return (React.createElement("div", { className: `form-group ${className || ''}` },
        header ? header : title && React.createElement("h2", { className: "fields-title" }, title),
        help && !toggleableHelp && React.createElement("div", { className: "field-help mute" }, help),
        help && toggleableHelp ?
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col d-flex" },
                        React.createElement("div", { className: "flex-fill" }, children),
                        React.createElement(LocalizeButton, { className: "ml-3", type: "info", onClick: helpButtonClickCallback },
                            React.createElement(HelpIcon, { iconSize: 'lg' })))),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col mt-2" }, showHelpText && React.createElement(React.Fragment, null,
                        React.createElement(HelpIcon, null),
                        " ",
                        help))))
            : children));
};
//# sourceMappingURL=FormGroup.js.map